export const transferInitialValues = {
  deJustificativa: '',
  nuProcesso: '',
  nuTermoPermissao: '',
  nuTermoTransferencia: '',
  dtPublicacao: new Date(),
  dtVigencia: null,
  dtTransferencia: null,
};

export const transferStripInitialValues = {
  deJustificativa: '',
  nuProcesso: '',
  nuTermoPermissao: '',
  nuTermoTransferencia: '',
  deCnpj: '',
  deRazaoSocial: '',
  dtAssinatura: new Date(),
  dtPublicacao: new Date(),
};
